export default "__VITE_ASSET__BawjXjj7__"